import * as Yup from "yup";

export const getIndustryValidationSchema = (
  isEditing = false,
  hasExistingImage = false,
) =>
  Yup.object({
    title: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Only letters are allowed")
      .required("Industry title is required"),

    slug: Yup.string()
      .matches(
        /^[a-z0-9-]+$/,
        "Slug must contain lowercase letters, numbers and hyphens only",
      )
      .required("Slug is required"),

    location: Yup.string().required("Location is required"),

    image:
      isEditing && hasExistingImage
        ? Yup.mixed().nullable()
        : Yup.mixed().required("Industry image is required"),
  });

export const industryValidationSchema = getIndustryValidationSchema();
